import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import moment from "moment";
import {
  Checkbox,
  TableRow,
  TableCell,
  IconButton,
  Collapse
} from "@mui/material";
import EditIcon from "@mui/icons-material/EditOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutline";
import PropTypes from "prop-types";
import ExpandLess from "@mui/icons-material/ExpandLess";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  expandIcon: {
    float: "right"
  },
  checkboxColumn: {
    borderBottom: "none"
  },
  selectedRow: {
    background: theme.palette.action.hover
  },
  row: theme.mixins.hoverableRow,
  selectedCell: {
    borderTop: `${theme.palette.primary.main} solid 2px`,
    borderBottom: "none",
    fontWeight: 500
  },
  cell: {
    borderBottom: `${theme.palette.divider} solid 1px`
  },
  messageRowHidden: {
    display: "none"
  },
  messageContent: {
    padding: theme.spacing(2.25, 8, 6, 8),
    background: theme.palette.action.hover,
    borderBottom: `${theme.palette.primary.main} solid 2px`
  },
  rowHover: {
    "&:hover $actions": {
      opacity: 1
    },
    "&:hover $titleContentContainer > span": {
      color: theme.palette.primary.main
    }
  },
  titleContentContainer: {
    position: "relative"
  },
  actions: {
    position: "absolute",
    opacity: 0,
    padding: theme.spacing(0, 1),
    whiteSpace: "nowrap",
    top: 0,
    right: 0,
    height: "100%",
    display: "flex",
    alignItems: "center",
    "& > button": {
      marginRight: theme.spacing(1)
    }
  }
}));
function AnnouncementsListRow(props) {
  const classes = useStyles();
  const { rowData, expanded } = props;
  const [checked, setChecked] = React.useState(false);

  const onCheckbox = ev => {
    ev.stopPropagation();
    props.onCheckboxClick(rowData.id, !checked);
    setChecked(!checked);
  };

  return (
    <>
      <TableRow
        key={rowData.id}
        hover={true}
        className={expanded ? classes.selectedRow : classes.row}
        classes={{ hover: classes.rowHover }}
        onClick={() => props.onExpand(rowData.id)}
      >
        {props.allowEdit && (
          <TableCell
            padding="checkbox"
            className={clsx(classes.checkboxColumn, {
              [classes.selectedCell]: expanded
            })}
          >
            <Checkbox checked={checked} onClick={ev => onCheckbox(ev)} />
          </TableCell>
        )}
        <TableCell className={expanded ? classes.selectedCell : classes.cell}>
          <div className={classes.titleContentContainer}>
            <span>{rowData.title}</span>
            {props.allowEdit && (
              <div className={classes.actions}>
                <IconButton
                  size="small"
                  onClick={props.onEditRowClick(rowData)}
                >
                  <EditIcon color="primary" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={props.onDeleteRowClick(rowData)}
                >
                  <DeleteIcon color="primary" />
                </IconButton>
              </div>
            )}
          </div>
        </TableCell>
        <TableCell className={expanded ? classes.selectedCell : classes.cell}>
          {rowData.postDate &&
            moment(rowData.postDate).format("MMM D, YYYY h:mm A")}
        </TableCell>
        <TableCell className={expanded ? classes.selectedCell : classes.cell}>
          {rowData.endDate &&
            moment(rowData.endDate).format("MMM D, YYYY h:mm A")}
        </TableCell>
        {props.allowEdit && (
          <TableCell className={expanded ? classes.selectedCell : classes.cell}>
            {rowData.status}
            {expanded ? (
              <ExpandLess color="primary" className={classes.expandIcon} />
            ) : null}
          </TableCell>
        )}
      </TableRow>
      <TableRow
        className={clsx({
          [classes.messageRowHidden]: !expanded
        })}
      >
        <TableCell colSpan="5" className={classes.messageContent}>
          <Collapse in={expanded}>
            <div dangerouslySetInnerHTML={{ __html: rowData.body }} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

AnnouncementsListRow.propTypes = {
  rowData: PropTypes.objectOf(PropTypes.any).isRequired,
  expanded: PropTypes.bool,
  allowEdit: PropTypes.bool,
  onCheckboxClick: PropTypes.func.isRequired,
  onEditRowClick: PropTypes.func.isRequired,
  onDeleteRowClick: PropTypes.func.isRequired
};
AnnouncementsListRow.defaultProps = {
  allowEdit: false
};

export default AnnouncementsListRow;
